import { FragmentId } from '../../records/entities/metadata/metadata.entity';
import { ExportLocationId, ExportLocationOptions } from './export-location.entity';

export interface ExportRequest {
    Records: ExportRequestEntry[];
    Filename?: string;
    ExportLocationId?: ExportLocationId;
    Reason?: string;
    EventType?: string;
    DestinationPath?: string;
    ExportSource: ExportSource;
    Options?: ExportLocationOptions;
    Tag?: string;
}

export interface ExportRequestEntry {
    RecordId: FragmentId;
    Filename?: string;
    Partial?: ExportRequestPartial;
}

export interface ExportRequestPartial {
    Type: PartialType;
    Start: number;
    End: number;
}

export enum ExportSource {
    ORIGINAL = 'Original',
    ACCESS = 'Access',
    ORIGINAL_AND_ACCESS = 'OriginalAndAccess'
}

export enum PartialType {
    BYTES = 'Bytes',
    FRAMES = 'Frames'
}

export enum ExportRequestCombineOption {
    ZIP = 'Zip',
    ZIPTREE = 'ZipTree',
    JOIN = 'Join',
    NONE = 'None'
}
